import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24c7c1fc")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")

  return (_openBlock(), _createBlock(_component_el_select, {
    placeholder: "",
    onRemoveTag: _ctx.removeTagHandler,
    onChange: _ctx.changeOptions
  }, {
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item[_ctx.valueKey],
          label: item[_ctx.labelKey],
          value: item[_ctx.valueKey],
          disabled: item.disabled
        }, null, 8, ["label", "value", "disabled"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["onRemoveTag", "onChange"]))
})